module.exports = __webpack_public_path__ + "static/media/remidio.74fd9c5f.png";